import { post, get } from './api';

export function getLink() {
    return get('refinance/getLink')
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}


// WEBPACK FOOTER //
// ./src/services/api/refinance.js